import { lazy } from "react";
import { Outlet } from "react-router";
import { RoleGuard } from "../contexts/RoleGuard";
import { AuthGuard } from "../utils/AuthGuard";
import { ScreenLoader } from "../utils/ScreenLoader";

const SellerList = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerList")),
);

const SellerListDaily = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerListDaily")),
);

const SellerCreate = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerCreate")),
);

const SellerReport = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerReport")),
);

const SellerReportDaily = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerReportDaily")),
);

const SellerUserList = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerUserList")),
);

const SellerMoveUser = ScreenLoader(
  lazy(() => import("../screens/seller-screen/SellerMoveUsers")),
);
//maping the seller route completely
export const SellerRoute = () => ({
  path: "seller",
  element: (
    <AuthGuard>
      <Outlet />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: (
        <RoleGuard
          requiredPermission="sellerManagement"
          requiredActions={["isRead"]}
        >
          <SellerList />
        </RoleGuard>
      ),
    },
    {
      path: "create",
      element: (
        <RoleGuard
          requiredPermission="sellerManagement"
          requiredActions={["isCreate"]}
        >
          <SellerCreate />
        </RoleGuard>
      ),
    },
    {
      path: "update/:id",
      element: (
        <RoleGuard
          requiredPermission="sellerManagement"
          requiredActions={["isUpdate", "isRead"]}
        >
          <SellerCreate />
        </RoleGuard>
      ),
    },
    {
      path: "report/:id",
      element: (
        <RoleGuard
          requiredPermission="sellerManagement"
          requiredActions={["isRead"]}
        >
          <SellerReport />
        </RoleGuard>
      ),
    },
    {
      path: "daily",
      element: (
        <RoleGuard
          requiredPermission="sellerManagement"
          requiredActions={["isRead"]}
        >
          <SellerListDaily />
        </RoleGuard>
      ),
    },
    {
      path: "daily-report/:id",
      element: (
        <RoleGuard
          requiredPermission="sellerManagement"
          requiredActions={["isRead"]}
        >
          <SellerReportDaily />
        </RoleGuard>
      ),
    },
    {
      path: "user/:id",
      element: (
        <RoleGuard
          requiredPermission="sellerManagement"
          requiredActions={["isRead"]}
        >
          <SellerUserList />
        </RoleGuard>
      ),
    },
    {
      path: "move-user/:id",
      element: (
        <RoleGuard
          requiredPermission="sellerManagement"
          requiredActions={["isRead", "isUpdate"]}
        >
          <SellerMoveUser />
        </RoleGuard>
      ),
    },
  ],
});
